import { render } from "./MainBanner.vue?vue&type=template&id=0ed99ff2&scoped=true"
import script from "./MainBanner.vue?vue&type=script&lang=js"
export * from "./MainBanner.vue?vue&type=script&lang=js"

import "./MainBanner.vue?vue&type=style&index=0&id=0ed99ff2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed99ff2"]])

export default __exports__